module.exports = __webpack_public_path__ + "static/jessica-fadel-dumbledore-bw-d3cdb2d5e6d9fa7037b1d7220f8b9638.jpeg";